import { render, staticRenderFns } from "./ResourcePlanningReportMaterialItems.vue?vue&type=template&id=5cb921de&"
import script from "./ResourcePlanningReportMaterialItems.vue?vue&type=script&lang=js&"
export * from "./ResourcePlanningReportMaterialItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports